export const employeeBenefits = [
  {
    label: 'Health Insurance',
    value: 'Health Insurance'
  },
  {
    label: 'Retirement Plans',
    value: 'Retirement Plans'
  },
  {
    label: 'Paid Time Off (PTO)',
    value: 'Paid Time Off (PTO)'
  },
  {
    label: 'Life Insurance',
    value: 'Life Insurance'
  },
  {
    label: 'Disability Insurance',
    value: 'Disability Insurance'
  },
  {
    label:
      'Flexible Spending Accounts (FSAs) and Health Savings Accounts (HSAs)',
    value:
      'Flexible Spending Accounts (FSAs) and Health Savings Accounts (HSAs)'
  },
  {
    label: 'Employee Assistance Programs (EAPs)',
    value: 'Employee Assistance Programs (EAPs)'
  },
  {
    label: 'Tuition Reimbursement',
    value: 'Tuition Reimbursement'
  },
  {
    label: 'Gym Memberships or Wellness Programs',
    value: 'Gym Memberships or Wellness Programs'
  },
  {
    label: 'Childcare Assistance',
    value: 'Childcare Assistance'
  },
  {
    label: 'Commuter Benefits',
    value: 'Commuter Benefits'
  },
  {
    label: 'Stock Options or Equity Grants',
    value: 'Stock Options or Equity Grants'
  },
  {
    label: 'Professional Development',
    value: 'Professional Development'
  },
  {
    label: 'Bonuses and Incentive Programs',
    value: 'Bonuses and Incentive Programs'
  },
  {
    label: 'Paid Parental Leave',
    value: 'Paid Parental Leave'
  },
  {
    label: 'Employee Discounts',
    value: 'Employee Discounts'
  },
  { label: 'Legal Assistance', value: 'Legal Assistance' },
  { label: 'Adoption Assistance', value: 'Adoption Assistance' },
  { label: 'Relocation Assistance', value: 'Relocation Assistance' },
  { label: 'Flextime and Telecommuting', value: 'Flextime and Telecommuting' },
  {
    label: 'Employee Recognition Programs',
    value: 'Employee Recognition Programs'
  },
  { label: 'Long-term Care Insurance', value: 'Long-term Care Insurance' },
  { label: 'Annual leave', value: 'Annual leave' },
  { label: 'Dental insurance', value: 'Dental insurance' },
  { label: 'Education', value: 'Education' },
  { label: 'Stock', value: 'Stock' }
];
